import { FREIGHT_MODE_KEYS, FREIGHT_MODE_LABELS } from '../../../../constants/freightModes';

export const NATUREZA_LABELS: Record<string, string> = {
  VENDA_MERCADORIA: 'Venda de Mercadoria',
  COMPRA: 'Compra',
  DEVOLUCAO_MERCADORIA: 'Devolução de Mercadoria',
  REMESSA: 'Remessa',
  RETORNO: 'Retorno',
  TRANSFERENCIA: 'Transferência',
  EXPORTACAO: 'Exportação',
  IMPORTACAO: 'Importação',
  INDUSTRIALIZACAO: 'Industrialização',
  AMOSTRA_GRATIS: 'Amostra Grátis',
};

export const TIPO_OPERACAO_LABELS: Record<string, string> = {
  SAIDA: '1 — Saída',
  ENTRADA: '0 — Entrada',
};

export const FINALIDADE_LABELS: Record<string, string> = {
  NORMAL: '1 — NF-e Normal',
  COMPLEMENTAR: '2 — Complementar',
  AJUSTE: '3 — Ajuste',
  DEVOLUCAO_MERCADORIA: '4 — Devolução',
};

export const FRETE_LABELS: Record<string, string> = FREIGHT_MODE_LABELS;

export const FRETE_MODOS_SELECIONAVEIS = FREIGHT_MODE_KEYS;

export const FORMA_PAGAMENTO_LABELS: Record<string, string> = {
  Dinheiro: 'Dinheiro',
  Cheque: 'Cheque',
  CartaoDeCredito: 'Cartão de Crédito',
  CartaoDeDebito: 'Cartão de Débito',
  BoletoBancario: 'Boleto Bancário',
  DepositoBancario: 'Depósito Bancário',
  PagamentoInstantaneoPix: 'Pix',
  PagamentoInstantaneoPixEstatico: 'Pix Estático',
  TransferenciaBancariaCarteiraDigital: 'Transferência / Carteira Digital',
  SemPagamento: 'Sem Pagamento',
  Outros: 'Outros',
};

export const formaPagamentoLabel = (name?: string, fallbackId?: number): string =>
  (name && FORMA_PAGAMENTO_LABELS[name]) || name || `Forma ${fallbackId}`;

export const rotuloNota = (
  serie: string | number | null | undefined,
  numeroNF: string | number | null | undefined,
  id: number | string | undefined,
): string => (serie && numeroNF ? `série ${serie} · nº ${Number(numeroNF)}` : `#${id}`);
